/* eslint-disable */
import React, { Component } from 'react';
import { Table, Button, Header, Icon, Modal } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { getProfissionaisExecutantes, deleteProfissionalExecutante } from '@store/actions';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import m from '@utils/strings';
import '@styles/geracao-lote-cobranca.css';

class TableCobrancas extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tableRows: [],
            column: null,
            direction: 'ascending',
            data: [],
            lastRequestParams: {},
            lastRequestWasFiltered: false,
            modal: null
        }

        this.checkboxesReferences = {};
        this.guiasSelecionadas = [];
    }   

    componentDidMount() {
        this.props.updateTableRows(this.updateTableRows);
        this.props.applyFilterTable(this.applyFilterTable);
        this.props.updateApplyingFilter(this.updateApplyingFilter);
        this.props.resetGuiasSelecionadas(this.resetGuiasSelecionadas);
    }

    mapTableRowJSX = (list) => {
        return list.map(
            (profissional) => {
                let profissionalExecutante = profissional.ProfissionalExecutante;

                return (
                    <Table.Row key={profissionalExecutante.Id}>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {profissionalExecutante.Nome}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {profissionalExecutante.Conselho}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {profissionalExecutante.Numeroconselho}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {profissionalExecutante.Estado}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <div className='td-cobranca-left-align'>
                                {`${profissional.Ocupacoes.length > 0? profissional.Ocupacoes[0].Descricao : ''} ${profissional.Ocupacoes.length > 1? `(+${profissional.Ocupacoes.length-1})` : ''}`}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <Link 
                                to={{ 
                                    pathname: '/cadastrar-editar-profissional', 
                                    state: { 
                                        idProfissional: profissionalExecutante.Id,
                                        nome: profissionalExecutante.Nome, 
                                        ocupacoes: profissional.Ocupacoes,
                                        conselho: profissionalExecutante.Conselho,
                                        numeroConselho: profissionalExecutante.Numeroconselho,
                                        estado: profissionalExecutante.Estado,
                                    } 
                                }}>
                                <div className='td-cobranca-center-align'>
                                    <img src="./images/editar.png" />
                                </div>
                            </Link>
                        </Table.Cell>
                        <Table.Cell>
                            <div 
                                className='td-cobranca-center-align cursor-pointer'
                                onClick={() => {
                                    this.setState({ modal: { isOpened: true, idProfissionalToRemove: profissionalExecutante.Id } });
                                }}
                            >
                                <img src="./images/x.png" />
                            </div>
                        </Table.Cell>
                    </Table.Row>
                );
            }
        );
    }

    loadTableRows = (willFilter, params) => {

        let mapSuccessFunction = (result) => {
            if(_.isEmpty(result.data))
                this.props.callSnackbar(m.TELA_PROFISSIONAIS_EXECUTANTES.NOTIFICACAO_SUCESSO_RETORNO_VAZIO, 'success');
            let tableRows = this.mapTableRowJSX(result && result.data? result.data : []);
            this.setState({ tableRows: tableRows, data: result && result.data? result.data : [] });
        }

        let mapErrorFunction = (error) => {
            this.props.callSnackbar(m.TELA_PROFISSIONAIS_EXECUTANTES.NOTIFICACAO_ERRO_SERVIDOR, 'error')
        }

        if (willFilter) {
            params.idPrestador = this.props.prestador.Id;
            this.props.getProfissionaisExecutantesFiltered(params, mapSuccessFunction, mapErrorFunction);
        }
        else {
            this.props.getProfissionaisExecutantes(this.props.prestador.Id, mapSuccessFunction, mapErrorFunction);
        }
        
    }
   
    applyFilterTable = (params) => {
        if (params) {
            this.setState({ lastRequestWasFiltered: true, lastRequestParams: params });
            this.loadTableRows(true , params);
        }
        else {
            this.setState({ lastRequestWasFiltered: false, lastRequestParams: {} });
            this.loadTableRows(false);
        }
    }

    handleSort = (clickedColumn) => {
        let { column, direction, data } = this.state;
        let map = this.mapTableRowJSX(data);
        
        if (column !== clickedColumn) {
            let dataSorted = _.sortBy(data, [`profissionalExecutante.${clickedColumn}`]);
            map = this.mapTableRowJSX(dataSorted);
            this.setState({
                data: dataSorted.reverse(),
                column: clickedColumn,
                tableRows: map,
            });
        }

        if (column !== clickedColumn) {
            this.setState({
                tableRows: map.reverse(),
                direction: direction === 'ascending'? 'descending' : 'ascending'
            });
        } else {
            this.setState({
                data: data.reverse(),
                tableRows: map.reverse(),
                direction: direction === 'ascending'? 'descending' : 'ascending'
            });
        }
    }

    render() {
        let { column, direction, tableRows, lastRequestWasFiltered, lastRequestParams, modal } = this.state;

        return (
            <div className='wrapper'>
                <div className='layout-table-guias-body'>
                    <Table striped sortable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell 
                                    sorted={column === 'nome'? direction : null}
                                    onClick={() => {this.handleSort('nome')}} >
                                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_NOME_PROFISSIONAL}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'conselho'? direction : null}
                                    onClick={() => {this.handleSort('conselho')}}>
                                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_CONSELHO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'numeroconselho'? direction : null}
                                    onClick={() => {this.handleSort('numeroconselho')}}>
                                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_NUMERO_CONSELHO}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    sorted={column === 'estado'? direction : null}
                                    onClick={() => {this.handleSort('estado')}}>
                                   {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_ESTADO}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_OCUPACAO}
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <div className='text-align-center'>
                                        {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_EDITAR}
                                    </div>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <div className='text-align-center'>
                                        {m.TELA_PROFISSIONAIS_EXECUTANTES.LABEL_TABLE_APAGAR}
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tableRows}
                        </Table.Body>
                    </Table>
                </div>
                <div className='div-separador-top-bottom-50' />

                <Modal open={modal? modal.isOpened : false} className='modal-layout scrolling'>
                    <Header content={m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_TITULO_REMOVER_PROFISSIONAL} className={"form-header-title"} />
                    <Modal.Content>
                    <p className='modal-description-text'>
                        {m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_MENSAGEM_REMOVER_PROFISSIONAL}
                    </p>
                    </Modal.Content>
                    <Modal.Actions>
                    <Button 
                        color='red'
                        onClick={() => {
                            this.setState({ modal: null });
                        }}
                    >
                        <Icon name='remove' /> {m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_LABEL_NAO}
                    </Button>
                    <Button 
                        color='green'
                        onClick={() => {
                            if (modal) {
                                this.props.deleteProfissionalExecutante(
                                    modal.idProfissionalToRemove,
                                    (result) => {
                                        if(lastRequestWasFiltered)
                                            this.applyFilterTable(lastRequestParams);
                                        else
                                            this.applyFilterTable(null);
                                        
                                        this.setState({ modal: null });
                                    }, 
                                    (error) => {
                                        
                                    }
                                );
                            }
                        }}
                    >
                        <Icon name='checkmark' /> {m.TELA_PROFISSIONAIS_EXECUTANTES.MODAL_LABEL_SIM}
                    </Button>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

export default connect(null, { getProfissionaisExecutantes, deleteProfissionalExecutante })(TableCobrancas);
